<template>
  <div class="flex flex-col px-3 py-3 overflow-x-hidden">
    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full sm:px-6 lg:px-8">
        <div class="overflow-hidden border rounded-md">
          <table class="min-w-full">
            <thead class="bg-white dark:bg-gray-700">
              <tr>
                <th class="w-1/5 border-b py-2.5" colspan="1">
                  <div>
                    <span class="font-manrope font-normal">Name</span>
                    <button
                      v-if="getCurrentRT.enable_annonymous"
                      type="button"
                      class="bg-white rounded ml-2 px-2"
                      @click="enableRealIdentity()"
                    >
                      <i v-if="privateIdentity === true" class="fa fa-solid fa-eye"></i>
                      <i v-else class="fa fa-eye-slash"></i>
                    </button>
                  </div>
                </th>
                <th class="w-2/12 border-l border-r border-b bg-blueTable-light font-manrope font-normal" colspan="3">
                  Submission
                </th>
                <th class="w-1/12 border-b border-r font-manrope font-normal">Read</th>
                <th class="w-1/12 border-b border-r bg-redTable-light font-manrope font-normal" colspan="2">
                  Comments
                </th>
                <th class="bg-greenTable-light border-b font-manrope font-normal" :colspan="assessmentsColspan + 3" rowspan="1">
                  Assessment
                </th>
              </tr>
              <tr>
                <th class="py-2.5 border-b border-r">
                  <select v-model="selectedOrderList" class="px-3 py-1.5 text-sm font-normal text-gray-700 bg-white focus:text-gray-700 cursor-pointer focus:outline-none border rounded border-blueGray">
                    <option value="name-asc">Name A-Z</option>
                    <option value="name-desc">Name Z-A</option>
                    <option value="last-name-desc">Last Name Z-A</option>
                    <option value="last-name-asc">Last Name A-Z</option>
                  </select>
                </th>
                <th class="border-l border-b border-r bg-blueTable-light font-manrope font-normal">
                  Complete
                </th>
                <th class="border-b border-r bg-blueTable-light font-manrope font-normal">Words</th>
                <th class="border-r border-b bg-blueTable-light font-manrope font-normal">
                  <i class="fa fa-solid fa-star"></i>
                </th>
                <th class="border-b border-r">
                  <i class="fa fa-solid fa-percent"></i>
                </th>
                <th class="bg-redTable-light border-r border-b">
                  <i class="fa fa-solid fa-hashtag"></i>
                </th>
                <th class="bg-redTable-light border-r border-b font-manrope font-normal">Words</th>
                <th v-if="getCurrentRT.enable_grading === true" v-for="a in assessments" :key="a.title" class="bg-greenTable-light border-r border-b font-manrope font-normal">
                  {{ a.title }}
                </th>
                <th class="bg-greenTable-light border-r border-b font-manrope font-normal">
                  Total Points
                </th>
                <th class="bg-greenTable-light border-r border-b font-manrope font-normal">
                  Written Feedback
                </th>
                <th class="bg-greenTable-light border-b font-manrope font-normal">Status</th>
              </tr>
            </thead>
            <tbody v-if="isLoading === false">
              <tr v-for="student in orderedTableData" :key="student.id" class="border-b cursor-pointer">
                <td class="px-4 py-3 border-r bg-white">
                  <div v-if="privateIdentity === true" class="flex space-x-2 items-center">
                    <img class="inline-block h-10 w-10 rounded-full ring-2 ring-white mr-2" :src="student.anonymous_identity.avatar_url" />
                    <div class="flex flex-col space-y-0.5">
                      <h6 class="text-sm text-gray-800 font-poppins">{{ student.anonymous_identity.name }}</h6>
                      
                    </div>
                  </div>
                  <div v-else class="flex space-x-2 items-center">
                    <img class="inline-block h-10 w-10 rounded-full ring-2 ring-white mr-2" :src="student.image" />
                    <div class="flex flex-col space-y-0.5">
                      <h6 class="text-sm text-gray-800 font-poppins">{{ student.name }}</h6>
                      <span class="text-xs font-poppins text-gray-700 font-light">{{ student.anonymous_identity.name }}</span>
                    </div>
                  </div>
                </td>
                <td class="border-r text-center bg-blueTable-light">
                  <div v-if="student.submission_started === true">
                    <i class="ml-2 fa fa-solid fa-check"></i>
                    <span class="underline cursor-pointer" @click="redirectToStudentFeedback(student.submission_id)">(View)</span>
                  </div>
                  <i v-else class="fa fa-solid fa-xmark"></i>
                </td>
                <td class="border-r text-center bg-blueTable-light">
                  {{ student.submission_words }}
                </td>
                <td class="border-r text-center bg-blueTable-light">
                  <i v-if="student.is_model" class="ml-2 fa fa-solid fa-check text-green-500"></i>
                  <div v-else>-</div>
                </td>
                <td class="border-r text-center bg-white">
                  {{ student.read }}
                </td>
                <td class="border-r text-center bg-redTable-light">
                  {{ student.comments_number }}
                </td>
                <td class="border-r text-center bg-redTable-light">
                  {{ student.comments_average_length }}
                </td>
                <td v-if="student.assessments.length && getCurrentRT.enable_grading === true" v-for="s in student.assessments" :key="s.title" class="border-r text-center bg-greenTable-light">
                  {{ s.value }}
                </td>
                <td 
                  v-if="!student.assessments.length && student.draft_assessments.length && getCurrentRT.enable_grading === true"
                  v-for="d in student.draft_assessments"
                  :key="d.title"
                  class="border-r text-center bg-greenTable-light"
                >
                  {{ d.value }}
                </td>
                <td
                  v-if="!student.assessments.length && !student.draft_assessments.length && getCurrentRT.enable_grading === true"
                  v-for="a in assessments"
                  :key="a.title"
                  class="border-r text-center bg-greenTable-light"
                >
                  -
                </td>
                <td v-if="!student.assessments.length && student.draft_assessments.length" class="border-r text-center bg-greenTable-light">
                  {{ student.total_draft_points }}
                </td>
                <td v-if="student.assessments.length" class="border-r text-center bg-greenTable-light">
                  {{ student.total_points }}
                </td>
                <td v-if="!student.assessments.length && !student.draft_assessments.length" class="border-r text-center bg-greenTable-light">
                  -
                </td>
                <td class="border-r text-center bg-greenTable-light">
                  <div v-if="student.teacher_feedback !== ''">Yes</div>
                  <div v-if="student.teacher_feedback === '' && student.draft_teacher_feedback === ''">
                    -
                  </div>
                  <div v-if="student.draft_teacher_feedback !== '' && student.teacher_feedback === ''">
                    Draft
                  </div>
                </td>
                <td class="text-center bg-greenTable-light">
                  <div v-if="student.assessments.length || student.teacher_feedback !== ''" \class="hover:underline text-green-500" @click="redirectToStudent(student.submission_id)">
                    Sent
                  </div>
                  <div v-else-if="student.draft_assessments.length || student.draft_teacher_feedback !== ''" class="hover:underline" @click="redirectToStudent(student.submission_id)">
                    Draft
                  </div>
                  <div v-else>-</div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(skeletonLoader, index) in 2" :key="index" class="border-b">
                <td class="p-3 border-r bg-gray-50" rowspan="1">
                  <div class="flex items-center animate-pulse">
                    <div class="w-8 bg-gray-300 h-7 mr-2 rounded-full"></div>
                    <div class="w-full h-3 bg-gray-200 dark:bg-gray-700"></div>
                  </div>
                </td>
                <td
                  v-for="(skeletonLoader, index1) in skeletonLoaders"
                  :key="index1"
                  class="p-3 border-r bg-gray-50"
                  rowspan="1"
                >
                  <div class="w-full h-3 bg-gray-200 dark:bg-gray-700"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import roundtableServices from 'features/onlineRoundtables/onlineRoundtables.services.js';
  import ExportEngagementDataModal from 'components/modals/exportEngagementDataModal';
  import { EventBus } from '../../../../utils/event-bus';

  export default Vue.extend({
    components: {
      ExportEngagementDataModal,
    },
    computed: {
      ...mapGetters(['getCurrentRT', 'getOrderedSubmissions']),
      assessments() {
        if (this.getCurrentRT.enable_grading){
          return this.getCurrentRT.points_settings.peer_rewards;
        }
          
        return [];
      },
      assessmentsColspan() {
        if (this.getCurrentRT.enable_grading)
          return this.getCurrentRT.points_settings.peer_rewards.length;
        return 0;
      },
      orderedTableData() {
        switch (this.selectedOrderList) {
          case 'name-asc':
            if (this.privateIdentity) {
              return this.tableData.sort((a, b) =>
                a.anonymous_identity.name.localeCompare(
                  b.anonymous_identity.name
                )
              );
            } else {
              return this.tableData.sort((a, b) =>
                a.name.localeCompare(b.name)
              );
            }
          case 'name-desc':
            if (this.privateIdentity) {
              return this.tableData.sort((a, b) =>
                b.anonymous_identity.name.localeCompare(
                  a.anonymous_identity.name
                )
              );
            } else {
              return this.tableData.sort((a, b) =>
                b.name.localeCompare(a.name)
              );
            }
          case 'last-name-desc':
            if (this.privateIdentity) {
              return this.tableData.sort((a, b) =>
                b.anonymous_identity.lastName.localeCompare(
                  a.anonymous_identity.lastName
                )
              );
            } else {
              return this.tableData.sort((a, b) =>
                b.lastName.localeCompare(a.lastName)
              );
            }
          case 'last-name-asc':
            if (this.privateIdentity) {
              return this.tableData.sort((a, b) =>
                a.anonymous_identity.lastName.localeCompare(
                  b.anonymous_identity.lastName
                )
              );
            } else {
              return this.tableData.sort((a, b) =>
                a.lastName.localeCompare(b.lastName)
              );
            }
        }
      },
      skeletonLoaders() {
        return 9 + this.getCurrentRT.points_settings.peer_rewards.length;
      },
    },
    data() {
      return {
        isLoading: Boolean,
        privateIdentity: false,
        isOrdering: false,
        tableData: [
          {
            comments_average_length: Number,
            comments_number: Number,
            image: String,
            is_model: Boolean,
            name: String,
            read: String,
            submission_id: String,
            submission_started: Boolean,
            submission_words: Number,
            teacher_feedback: String,
            total_points: Number,
            anonymous_identity: {
              name: String,
              id: String,
              avatar_url: String,
            },
          },
        ],
        selectedOrderList: 'name-asc',
      };
    },
    methods: {
      enableRealIdentity: function () {
        this.privateIdentity = !this.privateIdentity;
      },
      sortByStudentName: function () {
        if (this.isOrdering === true) {
          if (this.privateIdentity) {
            this.tableData.sort((a, b) =>
              b.anonymous_identity.name.localeCompare(a.anonymous_identity.name)
            );
          } else {
            this.tableData.sort((a, b) => b.name.localeCompare(a.name));
          }
        } else {
          if (this.privateIdentity) {
            this.tableData.sort((a, b) =>
              a.anonymous_identity.name.localeCompare(b.anonymous_identity.name)
            );
          } else {
            this.tableData.sort((a, b) => a.name.localeCompare(b.name));
          }
        }
        this.isOrdering = !this.isOrdering;
      },
      redirectToStudentFeedback: async function (submissionID) {
        await this.$store.dispatch('loadSubmission', submissionID);
        EventBus.$emit(
          'seeSubmissionStudentsTable',
          'discussion',
          submissionID
        );
      },
      redirectToStudent: function (submissionID) {
        this.$store.commit('setIsFromNotification', true);
        EventBus.$emit('seeFeedback', 'discussion', submissionID);
      },
    },
    mounted() {
      this.privateIdentity = this.getCurrentRT.enable_annonymous;
      roundtableServices
        .getSummaryTableData(this.getCurrentRT.id)
        .then((res) => {
          this.isLoading = true;
          /* Not the best way */
          res.data.map((data_table) => {
            const filteredAssessments = data_table.draft_assessments.filter(draft => {
              return this.getCurrentRT.points_settings.peer_rewards.some(reward => {
                return reward.title && reward.title === draft.title;
              });
            });
            const filteredAssessmentsSent = data_table.assessments.filter(draft => {
              return this.getCurrentRT.points_settings.peer_rewards.some(reward => {
                return reward.title && reward.title === draft.title;
              });
            });
            data_table.draft_assessments = filteredAssessments;
            data_table.assessments = filteredAssessmentsSent;
          });
          this.tableData = res.data;
          this.isLoading = false;
        });
    },
  });
</script>



// WEBPACK FOOTER //
// StudentsTable.vue?447f7103